import React from 'react';
import { PhoneIcon, MessageCircleIcon } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-[#1a3629] text-white py-16" data-id="element-31">
      <div className="container mx-auto px-4" data-id="element-32">
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-33">
          {/* Logo and tagline */}
          <div className="mb-8 md:mb-0" data-id="element-34">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1XgL9PHWTpLQw2LSGP2EPT/marco-leer_Logo.png" alt="Marco Leer" className="w-48 mb-4" data-id="element-35" />
            <p className="text-white text-lg font-medium" data-id="element-36">
              Specialist in het stofferen van boten en jachten sinds 1988.
            </p>
          </div>
          {/* Contact information - minimalistic */}
          <div className="flex flex-col items-center md:items-end space-y-4" data-id="element-37">
            <a href="tel:+31612345678" className="flex items-center text-white hover:opacity-80 transition-opacity" data-id="element-38">
              <PhoneIcon className="w-5 h-5 mr-2" data-id="element-39" />
              <span className="text-lg" data-id="element-40">06-12345678</span>
            </a>
            <a href="https://wa.me/31612345678" className="flex items-center text-white hover:opacity-80 transition-opacity" data-id="element-41">
              <MessageCircleIcon className="w-5 h-5 mr-2" data-id="element-42" />
              <span className="text-lg" data-id="element-43">WhatsApp</span>
            </a>
          </div>
        </div>
        {/* Copyright */}
        <div className="text-center mt-16 pt-8 border-t border-white/20" data-id="element-44">
          <p className="text-base" data-id="element-45">
            © {new Date().getFullYear()} Marco Leer. Alle rechten voorbehouden.
          </p>
          <p className="mt-2 text-base" data-id="element-46">Vakmanschap & Kwaliteit sinds 1988</p>
        </div>
      </div>
    </footer>;
};